import { render, staticRenderFns } from "./InternalPluginCreate.vue?vue&type=template&id=927774e4&scoped=true"
import script from "./InternalPluginCreate.vue?vue&type=script&lang=js"
export * from "./InternalPluginCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927774e4",
  null
  
)

export default component.exports